<template>
  <section id="kv" class="kv">
    <div class="container-fluid h-100">
      <hooper
        class="h-100"
        :autoPlay="true"
        :playSpeed="10000"
        :wheelControl="false"
        :keysControl="false"
      >
        <slide
          v-for="(item, index) in banner"
          :key="index"
          class="d-flex align-items-center justify-content-center"
        >
          <img v-lazy="item.thumb" :key="item.id" />
        </slide>
      </hooper>
    </div>
  </section>
</template>
<script>
import { Hooper, Slide } from 'hooper';

export default {
  name: 'kv',
  props: {
    banner: {
      type: Array,
      default: () => {},
    },
  },
  components: {
    Hooper,
    Slide,
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/all.scss';

#kv {
  overflow-x: hidden;
  background-color: lighten($secondary-white, 11%);
  padding: 0;
  max-height: 500px;
  @media (min-width: 576px) {
    height: 350px;
  }
  @media (min-width: 768px) {
    height: 400px;
  }
  overflow: hidden;
  .container-fluid {
    max-width: 1400px;
    padding: 0;
    li {
      margin: 0 auto;
      max-width: 1430px;
    }
  }
  img {
    width: 100%;
    height: auto;
    // background-color: $secondary-white;
    @media (min-width: 576px) {
      width: auto;
      height: 100%;
    }
  }
}
</style>
